export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    /* eslint-disable */
    /*let productSlider = jQuery('.product__slider');
    let variationImages = jQuery(`.variation__image`);*/

    /* Use the show_variation woocommerce hook to show the currently selected variation image if there is one (hook fires when a variation matches all selections) */
    jQuery('form.variations_form').on('show_variation', function(event, variation) {
      console.log(variation);
      const image_element = document.querySelector(`[data-thumbnail-id="${variation.image_id}"]`);
      if (image_element) {
        image_element.click();
      }
    });

    /* On clearing the selections remove the hidden class from product slider and add the hidden class to the variation images */
    jQuery('a.reset_variations').on('click', function() {
      const image_element = document.querySelector('[data-thumbnail-id]');
      if (image_element) {
        image_element.click();
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js